import { Fragment } from 'react';
import Citizenship from '../shared/citizenship';
import Fatherhood from '../shared/fatherhood';
import AccordionGenerality from '../shared/generality';
import Motherhood from '../shared/motherhood';
import CivilStatus from '../shared/civil-status';
import BirthdayDocument from '../shared/birthday-document';

interface SubscriptionBirthNonResidentProps {
  isCohabitation?: boolean;
  isAire?: boolean;
  isCitizenship?: boolean;
  isTransferNew?: boolean;
  isTransferAggregation?: boolean;
  validityEqualBirthday?: boolean;
  nonResident?: boolean;
  disabled?: boolean;
  isNotDisabledCitizenship?: boolean;
}

const SubscriptionBirthNonResident = ({
  isCohabitation = false,
  isAire = false,
  isCitizenship = false,
  isTransferNew = false,
  isTransferAggregation,
  validityEqualBirthday = true,
  nonResident = false,
  disabled,
  isNotDisabledCitizenship,
}: SubscriptionBirthNonResidentProps): React.ReactElement => {
  return (
    <Fragment>
      <AccordionGenerality
        isCohabitation={isCohabitation}
        isAire={isAire}
        nonResident={nonResident}
        disabled={disabled}
      />
      <BirthdayDocument
        isAire={isAire}
        isTransferNew={isTransferNew}
        isTransferAggregation={isTransferAggregation}
        disabled={disabled}
      />
      <Fatherhood
        isCohabitation={isCohabitation}
        isAire={isAire}
        isTransferNew={isTransferNew}
        disabled={disabled}
      />
      <Motherhood
        isCohabitation={isCohabitation}
        isAire={isAire}
        isTransferNew={isTransferNew}
        disabled={disabled}
      />
      <Citizenship
        isTransferNew={isTransferNew}
        isTransferAggregation={isTransferAggregation}
        validityEqualBirthday={validityEqualBirthday}
        disabled={isNotDisabledCitizenship ? false : disabled}
      />
      <CivilStatus isCitizenship={isCitizenship} disabled={disabled} />
    </Fragment>
  );
};

SubscriptionBirthNonResident.displayName = 'Subscription Birth Non resident component';

export default SubscriptionBirthNonResident;
